import { normalize } from 'normalizr';
import _find from 'lodash/find';
import _includes from 'lodash/includes';
import ApiService from '../../util/api';

import { draftListSchema } from '../schemas';

import { ORDERED_CUSTOMIZATION_TYPES, PRIMARY_CUSTOMIZATION_TYPES } from '../constants/Cards';

export const ActionTypes = {
  REQUEST_DRAFTS: 'zola/card/card_project/REQUEST_DRAFTS',
  RECEIVE_DRAFTS: 'zola/card/card_project/RECEIVE_DRAFTS',
  RECEIVE_DELETE_PROJECT: 'zola/cards/card_project/RECEIVE_DELETE_PROJECT',
};

function requestDrafts() {
  return {
    type: ActionTypes.REQUEST_DRAFTS
  };
}

function receiveDrafts(drafts) {
  return {
    type: ActionTypes.RECEIVE_DRAFTS,
    payload: {
      drafts
    }
  };
}

function receiveDeleteProject(projectUUID) {
  return {
    type: ActionTypes.RECEIVE_DELETE_PROJECT,
    payload: {
      projectUUID
    }
  };
}

export function fetchDrafts() {
  return (dispatch) => {
    dispatch(requestDrafts());
    return ApiService.get('/web-api/v2/card-project/projects/drafts')
      .then((json) => {
        const mappedDrafts = json.map(draft => ({
          ...draft,
          customizations: draft.customizations.sort((a, b) => ORDERED_CUSTOMIZATION_TYPES.indexOf(a.type) - ORDERED_CUSTOMIZATION_TYPES.indexOf(b.type)),
          primary_customization: _find(draft.customizations, customization => (
            _includes(PRIMARY_CUSTOMIZATION_TYPES, customization.type)
          ))
        }));
        const normalizedDrafts = normalize(mappedDrafts, draftListSchema);
        return dispatch(receiveDrafts(normalizedDrafts));
      });
  };
}

export function deleteProject(projectUUID) {
  return (dispatch) => {
    const requestBody = {
      projectUUID
    };
    return ApiService.delete(`/web-api/v2/card-project/${projectUUID}`, requestBody)
      .then(() => dispatch(receiveDeleteProject(projectUUID)));
  };
}



// WEBPACK FOOTER //
// ./src/cards/actions/draftsActions.js